import * as types from './actionTypes';
import * as API_END_POINTS from '../constants/api.js';
import axios from 'axios';
import { findIndex, map, cloneDeep, remove } from 'lodash';
import { appBasePath } from '../constants/staticData';
let uniqid = require('uniqid');

export function CreateVendorProfile(
  profileData,
  selectedFacilities,
  workingHours,
  isOldUser,
  batchID,
  router,
  imageIds
) {
  return dispatch => {
    let phone_no = profileData.phone;
    let profileDetails = {
      batch_id: batchID,
      companyprofilename: profileData.companyprofilename,
      displaytext: profileData.promotiontext,
      about: profileData.about,
      address: profileData.address,
      latitude: String(profileData.latitude),
      longitude: String(profileData.longitude),
      phone: '+971' + phone_no,
      email: profileData.email,
      website: profileData.website,
      ccpayment: profileData.card,
      cashpayment: profileData.cash,
      facilites: selectedFacilities,
      timings: workingHours,
      images: imageIds && imageIds.length ? imageIds : []
    };
    // if (workingHours.length) {
    //   profileDetails['timings'] = workingHours;
    // }
    axios
      .post(API_END_POINTS.GARAGE_PROFILE_DETAILS + '?imageflow=1', profileDetails, {
        withCredentials: true
      })
      .then(response => {
        if (response.status === 200 && response.data) {
          localStorage.setItem('garage_id', response.data.garageId);
          const authData = localStorage.getItem('businessAuthData')
            ? JSON.parse(localStorage.getItem('businessAuthData'))
            : {};
          authData.isGarageProfileCompleted = true;
          localStorage.setItem('businessAuthData', JSON.stringify(authData));

          if (!isOldUser && imageIds && imageIds.length && response.data) {
            dispatch(changeBusinessCoverImage(imageIds[0], [], false, dispatch));
          }

          if (profileData.company_logo.length) {
            if (profileData.company_logo[0].name != undefined) {
              dispatch(
                getSignedURL(
                  profileData.company_logo[0],
                  'logo',
                  false,
                  data => {
                    if (data) {
                      dispatch(
                        uploadImage(
                          profileData.company_logo[0],
                          data.signed_request,
                          data.url,
                          data.imageId,
                          false,
                          () => {
                            // dispatch(updateGarageLogo(data.url, true, false));
                            dispatch(changeCompanyLogo(data.url, false));
                          },
                          () => {
                            dispatch(updateGarageLogo(profileData.company_logo[0], false, false));
                          }
                        )
                      );
                    }
                  },
                  () => {
                    dispatch(updateGarageLogo(profileData.company_logo[0], false, false));
                  },
                  false
                )
              );
            }
          } else {
            dispatch(changeCompanyLogo('', false));
          }
          router.push(isOldUser ? `${appBasePath}/vendor-profile` : `${appBasePath}/vendor-profile/manage-services`);
          dispatch({
            type: types.VENDOR_PROFILE_DETAILS_UPDATED,
            isOldUser: isOldUser
          });
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: 'Profile saved successfully.',
            toastType: 'success'
          });
        } else {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: response.data && response.data.message
              ? response.data.message
              : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      })
      .catch(err => {
        if (err.config) {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      });
  };
}

export function getFacilities() {
  return dispatch => {
    axios
      .get(API_END_POINTS.GET_FACILITIES_MASTER, {
        withCredentials: true
      })
      .then(response => {
        if (response.status === 200 || response.status === 304) {
          dispatch({
            type: types.GET_FACILITIES_MASTER,
            facilitiesMasterList: response.data
          });
        } else {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: response.data && response.data.message ? response.data.message : 'Unable to fetch Facilities',
            toastType: 'error'
          });
        }
      })
      .catch(err => {
        if (err.config) {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      });
  };
}

export function getGarageProfile(garageId) {
  return dispatch => {
    axios
      .get(API_END_POINTS.GET_GARAGE_PROFILE + '?garageId=' + garageId + '&imageflow=1')
      .then(response => {
        if (response.status === 200 && response.data) {
          localStorage.setItem('garage_id', response.data.id);
          axios.defaults.headers.common['garage-id'] = response.data.id;
          dispatch({
            type: types.GET_GARAGE_PROFILE,
            garageProfileDetails: response.data
          });
        } else {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: response.data && response.data.message
              ? response.data.message
              : 'Unknown error occurred please try again',
            toastType: 'error'
          });
          dispatch({
            type: types.GET_GARAGE_PROFILE,
            unableToFetch: true
          });
        }
      })
      .catch(err => {
        if (err.config) {
          dispatch({
            type: types.GET_GARAGE_PROFILE,
            unableToFetch: true
          });
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      });
  };
}

export function getAllServices(fromAxiosAll) {
  if (fromAxiosAll) {
    return axios.get(API_END_POINTS.GET_PARENT_SERVICES);
  } else {
    return dispatch => {
      axios
        .get(API_END_POINTS.GET_PARENT_SERVICES, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200 && response.data) {
            dispatch({
              type: types.GET_ALL_SERVICES,
              allServices: response.data
            });
          } else {
            dispatch({
              type: types.SHOW_TOAST_MESSAGE,
              toastMessage: response.data && response.data.message
                ? response.data.message
                : 'Unknown error occurred please try again',
              toastType: 'error'
            });
          }
        })
        .catch(err => {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        });
    };
  }
}

function getGarageServices() {
  let garage_id = JSON.parse(localStorage.getItem('garage_id'));
  return axios.get(API_END_POINTS.GET_GARAGE_SERVICES + '?garage_id=' + garage_id);
}

function getAllManufacturers() {
  return axios.get(API_END_POINTS.GET_ALL_MANUFACTURERS, {
    withCredentials: true
  });
}

function getSupportedManufacturers() {
  let garage_id = JSON.parse(localStorage.getItem('garage_id'));
  return axios.get(API_END_POINTS.GET_SUPPORTED_MANUFACTURERS + '?garage_id=' + garage_id);
}

export function getGarageCategoryPrices(garage_id) {
  return dispatch => {
    axios
      .get(API_END_POINTS.GET_GARAGE_SERVICES + '?garage_id=' + garage_id, {
        withCredentials: true
      })
      .then(response => {
        dispatch({
          type: types.GET_SERVICES_VENDOR_PROFILE,
          allServices: response.data
        });
      });
  };
}

export function getServices(fromAddServices) {
  return dispatch => {
    let serviceRequests = [getAllServices(true), getAllManufacturers()];
    const authData = localStorage.businessAuthData ? JSON.parse(localStorage.businessAuthData) : '';
    if (authData && authData.isGarageProfileCompleted && authData.isGarageServiceSelected) {
      serviceRequests.push(getGarageServices(), getSupportedManufacturers());
    } else if (fromAddServices) {
      serviceRequests.push(getGarageServices());
    }
    axios
      .all(serviceRequests)
      .then(
        axios.spread(function(allServices, allManufacturers, garageServices, supportedManufacturers) {
          dispatch({
            type: types.GET_SERVICES,
            allServices: allServices.data,
            garageServices: garageServices ? garageServices.data : [],
            allManufacturers: allManufacturers.data,
            supportedManufacturers: supportedManufacturers ? supportedManufacturers.data : []
          });
        })
      )
      .catch(err => {
        //error
        if (err.config) {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : 'Unknown error occurred please try again',
            toastType: 'error'
          });
          dispatch({
            type: types.GET_SERVICES,
            unableToFetch: true
          });
        }
      });
  };
}

export function changeBusinessCoverImage(newImageId, imageArr, fromDelete, dispatch) {
  if (fromDelete) {
    changeCoverImage(newImageId, imageArr, dispatch);
  } else {
    return dispatch => {
      changeCoverImage(newImageId, imageArr, dispatch);
    };
  }
}

export function changeCoverImage(newImageId, imageArr, dispatch) {
  let garage_id = JSON.parse(localStorage.getItem('garage_id'));
  if (garage_id) {
    axios
      .post(API_END_POINTS.CHANGE_COVER_IMAGE + '?imageflow=1', {
        garage_id: garage_id,
        image_id: newImageId
      })
      .then(response => {
        if (response.status === 200) {
          dispatch({
            type: types.CHANGE_COVER_IMAGE,
            imageId: newImageId
          });
        } else {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: response.data && response.data.message
              ? response.data.message
              : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  }
}

export function changeCompanyLogo(newImage, fromVendorProfile) {
  return dispatch => {
    // const companyLogoFormData = new FormData();
    // companyLogoFormData.append('logo', newImage);
    axios
      .post(API_END_POINTS.GARAGE_COMPANY_LOGO + '?imageflow=1', { logo: newImage })
      .then(response => {
        if (response.status === 200) {
          dispatch({
            type: types.CHANGE_COMPANY_LOGO,
            updatedImage: newImage
          });
          if (fromVendorProfile) {
            dispatch({
              type: types.SHOW_TOAST_MESSAGE,
              toastMessage: 'Logo has been updated successfully',
              toastType: 'success'
            });
          }
        } else {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: response.data && response.data.message
              ? response.data.message
              : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      })
      .catch(err => {
        if (err.config && fromVendorProfile) {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      });
  };
}

export function createGarageProfileBatchId(batchID) {
  return dispatch => {
    const batchId = batchID ? batchID : uniqid();
    dispatch({
      type: types.CREATE_GARAGE_PROFILE_BATCH_ID,
      batch_id: batchId
    });
  };
}

export function clearGarageProfileBatchId() {
  return dispatch => {
    dispatch({
      type: types.CLEAR_GARAGE_PROFILE_BATCH_ID
    });
  };
}

export function removeGarageImage(imageId, images) {
  return dispatch => {
    dispatch({
      type: types.DELETE_GARAGE_IMAGE,
      imageId: imageId
    });
    if (imageId) {
      axios.delete(API_END_POINTS.DELETE_GARAGE_IMAGES + imageId, { withCredentials: true }).then(() => {
        let updatedImageArray = cloneDeep(images);
        if (images.length) {
          remove(updatedImageArray, function(n) {
            return n.id == imageId;
          });
          if (updatedImageArray.length) {
            let coverImageIndex = findIndex(updatedImageArray, { isCover: true });
            if (coverImageIndex == -1) {
              changeBusinessCoverImage(updatedImageArray[0].id, updatedImageArray, true, dispatch);
            }
          }
        }
      });
    }
  };
}

export function getRatingsAndReviews(garageId, start, count, sortKey, fromLoadMore) {
  return dispatch => {
    axios
      .get(
        API_END_POINTS.GET_REVIEWS_AND_RATINGS +
          '?garageId=' +
          garageId +
          '&start=' +
          start +
          '&count=' +
          count +
          '&' +
          sortKey,
        {
          withCredentials: true
        }
      )
      .then(response => {
        if (response.status === 200 && response.data) {
          dispatch({
            type: types.GET_REVIEWS_AND_RATINGS,
            ratingsAndReviews: response.data.reviewsDetails,
            ratingsOverview: response.data.overview,
            fromLoadMore: fromLoadMore
          });
        } else {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: response.data && response.data.message
              ? response.data.message
              : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}

export function addGarageServices(updatedServices, allServices, isEmergencyServices, parentServiceData, topLevelServiceData) {
  return dispatch => {
    let requestBody = createRequestData(updatedServices, allServices, isEmergencyServices, parentServiceData, topLevelServiceData);
    let serviceType = updatedServices && updatedServices.length && updatedServices[0] && updatedServices[0].service_id;
    axios
      .post(API_END_POINTS.ADD_GARAGE_SERVICES, requestBody)
      .then(response => {
        if (response && response.status === 200) {
          dispatch({
            type: types.ADD_GARAGE_SERVICES,
            updatedServices: updatedServices,
            serviceType: serviceType,
            unableToFetch: false
          });
          dispatch(getServices(true));
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: 'Services updated successfully.',
            toastType: 'success'
          });
        } else {
          dispatch({
            type: types.ADD_GARAGE_SERVICES,
            serviceType: serviceType,
            unableToFetch: true
          });
          dispatch(getServices(true));
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: response && response.data && response.data.message
              ? response.data.message
              : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      })
      .catch(err => {
        dispatch({
          type: types.ADD_GARAGE_SERVICES,
          serviceType: serviceType,
          unableToFetch: true
        });
        dispatch(getServices(true));
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : err.response.data.err ? err.response.data.err : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}

function createRequestData(updatedServices, allServices, isEmergencyServices, parentServiceData, topLevelServiceData) {
  let garage_id = JSON.parse(localStorage.getItem('garage_id'));
  let requestData = [];
  let newIndex = findIndex(updatedServices, { isNew: true });
  updatedServices.forEach((service) => {
    service.descp_sedan = service.descp_sedan ? service.descp_sedan : '';
    service.descp_suv = service.descp_suv ? service.descp_suv : '';
  });

  map(allServices, function(service) {
    let index = findIndex(updatedServices, { id: service.id });

    if (index == -1) {
      let newService = {
        cost_sedan: service.cost_sedan == "" ? service.cost_sedan : null,
        cost_suvs: service.cost_suvs == "" ? service.cost_suvs : null,
        descp_sedan: service.descp_sedan ? service.descp_sedan : '',
        descp_suv: service.descp_suv ? service.descp_suv : '',
        status: service.status,
        parentId: service.parentId,
        service_id: service.id,
        inspectionamount: service.inspectionamount,
        isinspectionrequired: service.isinspectionrequired
      };
      if (service.uniqueId) {
        newService['id'] = service.uniqueId;
      }
      requestData.push(newService);
    } else {
      let updatedService = updatedServices[index];
      requestData.push({
        id: updatedService.uniqueId ? updatedService.uniqueId : service.uniqueId,
        cost_sedan: updatedService.status ? updatedService.cost_sedan : service.cost_sedan,
        cost_suvs: updatedService.status ? updatedService.cost_suvs : service.cost_suvs,
        descp_sedan: updatedService.status ? updatedService.descp_sedan : service.descp_sedan,
        descp_suv: updatedService.status ? updatedService.descp_suv : service.descp_suv,
        status: updatedService.status,
        parentId: service.parentId,
        service_id: updatedService.id,
        inspectionamount: updatedService.inspectionamount,
        isinspectionrequired: updatedService.isinspectionrequired,
      });
    }
  });
  let updatedEmergencyServices = [];
  if (isEmergencyServices) {
    map(requestData, service => {
      if (service.status) {
        updatedEmergencyServices.push(service);
      } else {
        if (service.cost_sedan && service.cost_suvs) {
          updatedEmergencyServices.push(service);
        }
      }
    });
  }

  // Add Parent services for Repair
  parentServiceData && parentServiceData.forEach(pS => {
    let status = requestData.some(r => r.parentId === pS.id && r.status === 1) ? 1 : 0;
    let pService = {
      service_id: pS.id,
      status: status,
      id: pS.uniqueId,
      parentId: pS.parentId
    };
    requestData.push(pService);
  });

  // update Top Level Services
  if (topLevelServiceData) {
    let status = requestData.some(r => r.parentId === topLevelServiceData.id && r.status === 1) ? 1 : 0;
    let pService = {
      service_id: topLevelServiceData.id,
      status: status,
      id: topLevelServiceData.uniqueId
    };
    isEmergencyServices ? updatedEmergencyServices.push(pService) : requestData.push(pService);
  }

  let requestBody = {
    garage_id: garage_id,
    services: isEmergencyServices ? updatedEmergencyServices : requestData
  };
  return requestBody;
}

export function addManufacturers(manufacturers, router, currentComponentKey) {
  return dispatch => {
    let selectedManufacturers = [];
    map(manufacturers, brand => {
      if (brand.status) {
        selectedManufacturers.push(brand.id);
      }
    });
    axios
      .post(
        API_END_POINTS.GET_SUPPORTED_MANUFACTURERS,
        { mfrs: selectedManufacturers },
        {
          withCredentials: true
        }
      )
      .then(response => {
        if (response.status === 200) {
          const authData = localStorage.getItem('businessAuthData')
            ? JSON.parse(localStorage.getItem('businessAuthData'))
            : {};
          if (!authData.isGarageServiceSelected) {
            authData.isGarageServiceSelected = true;
            localStorage.setItem('businessAuthData', JSON.stringify(authData));
          }
          currentComponentKey && router.push(`${appBasePath}/${currentComponentKey}`);
          dispatch({
            type: types.ADD_MANUFACTURERS,
            manufacturers: manufacturers,
            unableToFetch: false
          });
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: currentComponentKey
              ? 'Thank you for completing the profile details. Your account is in verification pending and may take a few hours.'
              : 'Supported manufacturers updated successfully.',
            toastType: 'success'
          });
        } else {
          dispatch({
            type: types.ADD_MANUFACTURERS,
            unableToFetch: true
          });
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: response.data && response.data.message
              ? response.data.message
              : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      })
      .catch(err => {
        if (err.config) {
          dispatch({
            type: types.ADD_MANUFACTURERS,
            unableToFetch: false
          });
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      });
  };
}

export function addGarageProfilePicture(imageUploaded, batch_id) {
  return dispatch => {
    imageUploaded.map(value => {
      const formData = new FormData();
      formData.append('batch_id', batch_id);
      formData.append('photos', value);
      axios
        .post(API_END_POINTS.GARAGE_IMAGES, formData, {
          headers: {
            Accept: 'application/json,',
            'Content-Type': 'application/json'
          },
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200 && response.data) {
            let uploadedImage = {
              isUploaded: true,
              isFailed: false,
              localUniqueId: value.localUniqueId,
              id: response.data.id,
              thumbnail: response.data.medium,
              original: response.data.original,
              isCover: response.data.isCover
            };
            dispatch({
              type: types.UPLOAD_GARAGE_IMAGE_SUCCESS,
              batch_id: batch_id,
              image: uploadedImage
            });
          }
        })
        .catch(() => {
          let uploadedImage = {
            isUploaded: false,
            isFailed: true,
            thumbnail: URL.createObjectURL(value),
            original: URL.createObjectURL(value),
            localUniqueId: value.localUniqueId,
            isCover: false
          };
          dispatch({
            type: types.UPLOAD_GARAGE_IMAGE_FAILED,
            batch_id: batch_id,
            image: uploadedImage
          });
        });
    });
  };
}

export function getSignedURL(file, imageFor, batchID, callback, errorCallback, referenceID) {
  return dispatch => {
    let url = API_END_POINTS.S3_IMAGE_UPLOAD_SIGNED_REQUEST +
      '?file_name=' +
      file.name +
      '&file_type=' +
      file.type +
      '&for=' +
      imageFor;
    if (batchID) {
      url = url + '&batchid=' + batchID;
    }
    // only for garage profile edit
    if (referenceID) {
      url = url + '&referenceid=' + referenceID;
    }
    if (file && file.height && file.width) {
      url = url + '&height=' + file.height + '&width=' + file.width;
    }
    axios
      .get(url, {
        headers: {
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        if (response.status == 200 && response.data) {
          callback(response.data);
        } else {
          errorCallback(response.data && response.data.message);
          dispatch({
            type: types.SHOW_ERROR_MESSAGE,
            statusMessage: response.data && response.data.message
              ? response.data.message
              : 'Unknown error occurred please try again'
          });
        }
      })
      .catch(err => {
        errorCallback(err.response.data && err.response.data.message);
        dispatch({
          type: types.SHOW_ERROR_MESSAGE,
          statusMessage: err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again'
        });
      });
  };
}

export function uploadImage(file, signed_request, url, imageId, notifyServer, callback, errorCallback) {
  return dispatch => {
    axios
      .put(signed_request, file, {
        headers: {
          'Content-Type': file.type,
          'x-amz-acl': 'public-read'
        }
      })
      .then(response => {
        if (response.status == 200) {
          if (notifyServer) {
            dispatch(notifyImageUPloadSuccess(imageId, callback, errorCallback));
          } else {
            callback(imageId, true);
          }
        } else {
          errorCallback(response.data && response.data.message);
        }
      })
      .catch(err => {
        errorCallback(err.response.data && err.response.data.message);
        dispatch({
          type: types.SHOW_ERROR_MESSAGE,
          statusMessage: err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again'
        });
      });
  };
}

// only for garage Profile image upload.
export function notifyImageUPloadSuccess(imageId, callback, errorCallback) {
  return () => {
    axios
      .post(
        API_END_POINTS.S3_IMAGE_UPLOAD_DONE,
        { imageId: imageId },
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        }
      )
      .then(response => {
        if (response.status == 200) {
          callback(imageId, true);
        } else {
          errorCallback(response.data && response.data.message);
        }
      })
      .catch(err => {
        errorCallback(err.response.data && err.response.data.message);
      });
  };
}

export function addGarageProfilePictureTest(imageUploaded, batch_id, imageId, success) {
  return dispatch => {
    if (success) {
      let uploadedImage = {
        isUploaded: true,
        isFailed: false,
        localUniqueId: imageUploaded.localUniqueId,
        id: imageId,
        thumbnail: URL.createObjectURL(imageUploaded),
        original: URL.createObjectURL(imageUploaded),
        isCover: false
      };
      dispatch({
        type: types.UPLOAD_GARAGE_IMAGE_SUCCESS,
        batch_id: batch_id,
        image: uploadedImage
      });
    } else {
      let uploadedImage = {
        isUploaded: false,
        isFailed: true,
        thumbnail: URL.createObjectURL(imageUploaded),
        original: URL.createObjectURL(imageUploaded),
        localUniqueId: imageUploaded.localUniqueId,
        isCover: false
      };
      dispatch({
        type: types.UPLOAD_GARAGE_IMAGE_FAILED,
        batch_id: batch_id,
        image: uploadedImage
      });
    }
  };
}

export function updateGarageLogo(newImage, success, fromVendorProfile) {
  return dispatch => {
    if (success) {
      dispatch({
        type: types.CHANGE_COMPANY_LOGO,
        updatedImage: newImage
      });
      dispatch({
        type: types.SHOW_TOAST_MESSAGE,
        toastMessage: 'Logo has been updated successfully',
        toastType: 'success'
      });
    } else {
      if (fromVendorProfile) {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: 'Unable to update logo. please try again',
          toastType: 'error'
        });
      }
    }
  };
}

export function getVendorReviewsAndRatings(garageId, queryParams, offset, limit) {
  return dispatch => {
    let url = API_END_POINTS.GET_VENDOR_REVIEWS_AND_RATINGS + garageId;
    if (queryParams) {
      url = url + '&' + queryParams;
    }
    axios
      .get(url + '&start=' + offset + '&count=' + limit)
      .then(response => {
        if (response.status === 200) {
          dispatch({
            type: types.GET_VENDOR_REVIEWS_AND_RATINGS,
            reviewsAndRatingsData: response.data,
            offset: offset,
            unableToFetch: false
          });
        } else {
          dispatch({
            type: types.GET_VENDOR_REVIEWS_AND_RATINGS,
            unableToFetch: true
          });
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: response.data && response.data.message
              ? response.data.message
              : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      })
      .catch(err => {
        dispatch({
          type: types.GET_VENDOR_REVIEWS_AND_RATINGS,
          unableToFetch: true
        });
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}

export function addComments(comment, isEdit, reviewId, commentId) {
  return dispatch => {
    let url = API_END_POINTS.UPDATE_COMMENTS_ON_REVIEW;
    let requestBody = {};
    let method = '';
    if (isEdit) {
      method = 'PUT';
      requestBody = {
        id: commentId,
        comments: comment
      };
    } else {
      method = 'POST';
      requestBody = {
        review_id: reviewId,
        comments: comment
      };
    }
    axios({ method: method, url: url, data: requestBody })
      .then(response => {
        if (response.status === 200 && response.data) {
          // dispatch({
          //   type: types.SHOW_TOAST_MESSAGE,
          //   toastMessage: 'Profile saved successfully.',
          //   toastType: 'success'
          // });
          dispatch({
            type: types.UPDATE_COMMENTS_ON_REVIEW,
            reviewId: reviewId,
            responseData: response.data.data,
            isEdit: isEdit,
            commentId: commentId
          });
        } else {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: response.data && response.data.message
              ? response.data.message
              : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      })
      .catch(err => {
        if (err.config) {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      });
  };
}

export function deleteComments(commentId, reviewId) {
  return dispatch => {
    axios
      .delete(
        API_END_POINTS.UPDATE_COMMENTS_ON_REVIEW,
        {
          data: {
            id: commentId
          }
        },
        {
          withCredentials: true
        }
      )
      .then(response => {
        if (response.status === 200 && response.data) {
          dispatch({
            type: types.DELETE_COMMENTS_ON_REVIEW,
            reviewId: reviewId,
            commentId: commentId
          });
          // dispatch({
          //   type: types.SHOW_TOAST_MESSAGE,
          //   toastMessage: 'Profile saved successfully.',
          //   toastType: 'success'
          // });
        } else {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: response.data && response.data.message
              ? response.data.message
              : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      })
      .catch(err => {
        if (err.config) {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/vendorProfileActions.js